import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";

import { faq as str } from "$strings";

import installationPic from "../cubes.jpg";
import installationDetailPic from "../cubes-detail.jpg";

const FAQ = {
  [str.tell_me_more.question]: (
    <Fragment>
      <p dangerouslySetInnerHTML={{ __html: str.tell_me_more.part_1 }} />
      <img src={installationPic} alt={str.tell_me_more.installation_alt} />
      <p dangerouslySetInnerHTML={{ __html: str.tell_me_more.part_2 }} />
      <img src={installationDetailPic} alt={str.tell_me_more.detail_alt} />
    </Fragment>
  ),
  [str.can_i_see.question]: (
    <p dangerouslySetInnerHTML={{ __html: str.can_i_see.answer }} />
  ),
  [str.audio_recorded.question]: (
    <p dangerouslySetInnerHTML={{ __html: str.audio_recorded.answer }} />
  ),
  [str.when_will_video_be_added.question]: (
    <p
      dangerouslySetInnerHTML={{ __html: str.when_will_video_be_added.answer }}
    />
  ),
  [str.can_i_have_it_removed.question]: (
    <p dangerouslySetInnerHTML={{ __html: str.can_i_have_it_removed.answer }} />
  ),
  [str.who_will_see_it.question]: (
    <p dangerouslySetInnerHTML={{ __html: str.who_will_see_it.answer }} />
  ),
  [str.will_it_be_shown.question]: (
    <p dangerouslySetInnerHTML={{ __html: str.will_it_be_shown.answer }} />
  )
};

const Question = ({ children, question, id }) => {
  const [active, setActive] = useState(false);
  return (
    <li>
      <button
        className="Question"
        aria-expanded={active}
        aria-controls={`question-${id}`}
        onClick={() => setActive(!active)}
      >
        {(active ? "▾ " : "▸ ") + question}
      </button>
      <div
        id={`question-${id}`}
        className="Answer"
        aria-hidden={!active}
        style={{ display: active ? "flex" : "none" }}
      >
        {children}
      </div>
    </li>
  );
};

export default () => {
  return (
    // Question with arrow button
    <div id="FAQ" className="Faq">
      <header>{str.title}</header>
      <ul>
        {Object.entries(FAQ).map(([question, answer], i) => (
          <Question key={i} id={i} question={question}>
            {answer}
          </Question>
        ))}
      </ul>
    </div>
  );
};
